import React, { useState } from 'react';
import { EmployerLayout } from '../JobPostPricing/EmployerLayout';
import ApplicationList from './ApplicationList';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/Components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/Components/ui/dropdown-menu';
import { Plus, User, Filter, ArrowUpDown } from 'lucide-react';
import { getColor } from '@/config/theme';

export const Applications = () => {
  const navigate = useNavigate();
  const [sortValue, setSortValue] = useState('date');

  return (
    <EmployerLayout>
      <div className="flex flex-col gap-8 w-full">
        <div className="flex justify-end">
          <Button
            variant="outline"
            onClick={() => navigate('/hirewithus/postjob')}
            className="bg-muted hover:bg-muted/80"
          >
            <Plus className="w-5 h-5 mr-2" />
            <span className="px-3 py-2 border-2 border-primary rounded-lg">Post Job</span>
            <User className="w-5 h-5 ml-2" />
          </Button>
        </div>
        
        <div className="flex flex-col gap-12">
          <div className="flex-1 flex flex-col gap-12">
            <div className="flex justify-end gap-3">
              <Button variant="outline" size="sm">
                <Filter className="w-4 h-4 mr-2" />
                Filter
              </Button>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button 
                    variant="default" 
                    size="sm"
                    style={{
                      backgroundColor: getColor('primary'),
                      color: getColor('primaryForeground'),
                    }}
                  >
                    <ArrowUpDown className="w-4 h-4 mr-2" />
                    Sort
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-[188px]">
                  <DropdownMenuLabel>Sort by</DropdownMenuLabel>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={() => setSortValue('date')}>
                    <input
                      type="radio"
                      name="sort"
                      value="date"
                      checked={sortValue === 'date'}
                      onChange={() => setSortValue('date')}
                      className="mr-2"
                    />
                    Date
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => setSortValue('name')}>
                    <input
                      type="radio"
                      name="sort"
                      value="name"
                      checked={sortValue === 'name'}
                      onChange={() => setSortValue('name')}
                      className="mr-2"
                    />
                    Name
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => setSortValue('status')}>
                    <input
                      type="radio"
                      name="sort"
                      value="status"
                      checked={sortValue === 'status'}
                      onChange={() => setSortValue('status')}
                      className="mr-2"
                    />
                    Status
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
            <div>
              <ApplicationList />
            </div>
          </div>
        </div>
      </div>
    </EmployerLayout>
  );
};